// extracted by mini-css-extract-plugin
export default {"ContactsSearchExpand":"ContactSearch_ContactsSearchExpand__Ccb3y","expand":"ContactSearch_expand__T-D-g"};